import { useAemConfig } from '@as-react/common-components';
import { useMemo } from 'react';
export const useCategoryHierarchyTree = (categoryHierarchyTree, defaultFilter) => {
    const { lang } = useAemConfig();
    const getCategories = (filterString) => {
        let categoryList = [];
        const startKey = 'categories:c(';
        const endKey = ')';
        const splitKey = ';';
        const startKeyLength = startKey.length;
        const startKeyIndex = filterString ? filterString.indexOf(startKey) : -1;
        if (startKeyIndex !== -1) {
            const endKeyIndex = filterString.indexOf(endKey, startKeyIndex);
            categoryList = filterString
                .substring(startKeyIndex + startKeyLength, endKeyIndex)
                .split(splitKey)
                .map(item => parseInt(item, 10));
        }
        return categoryList;
    };
    const walkAndMapCategoryHierarchyTree = (node) => {
        var _a, _b, _c, _d;
        if (!((_c = (_b = (_a = node === null || node === void 0 ? void 0 : node.category) === null || _a === void 0 ? void 0 : _a.categoryTranslatedProperties) === null || _b === void 0 ? void 0 : _b[lang.toLocaleUpperCase()]) === null || _c === void 0 ? void 0 : _c.link)) {
            return null;
        }
        return {
            item: Object.assign({ categoryPath: node.categoryPath }, node.category),
            children: (_d = node.children) === null || _d === void 0 ? void 0 : _d.map(nodeChild => walkAndMapCategoryHierarchyTree(nodeChild)).filter(nodeChild => !!nodeChild),
        };
    };
    const categoryIds = useMemo(() => (categoryHierarchyTree && defaultFilter ? getCategories(defaultFilter) : []), [categoryHierarchyTree, defaultFilter]);
    const mappedCategoryHierarchyTree = useMemo(() => (categoryHierarchyTree && defaultFilter ? walkAndMapCategoryHierarchyTree(categoryHierarchyTree) : null), [categoryHierarchyTree, defaultFilter]);
    return { categoryIds, categoryHierarchyTree: mappedCategoryHierarchyTree };
};
